import { render, staticRenderFns } from "./webProduct.vue?vue&type=template&id=531e1c9f"
import script from "./webProduct.vue?vue&type=script&lang=js"
export * from "./webProduct.vue?vue&type=script&lang=js"
import style0 from "./webProduct.vue?vue&type=style&index=0&id=531e1c9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports